import React from 'react';
import FinanzasUI from '../../Admin/Finanzas/FinanzasUI';

const FinanzasContabilidadUI = () => {
  return <FinanzasUI apiBasePath="/api/contabilidad" />;
};

export default FinanzasContabilidadUI;